import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useCallback, useContext } from 'react';
import { LocaleContext } from '@zurich/common/contexts';
import { DatePicker } from '../DatePicker';
import { WithEndDecorator, } from '../WithEndDecorator';
export const ApiDatePicker = forwardRef(function ApiDatePicker(props, ref) {
    const { onChange, value, endDecorator, emptyEndDecorator, dataName, ...otherProps } = props;
    const { apiDateToDate, dateFormat, dateToApiDate } = useContext(LocaleContext);
    const handleChange = useCallback((date, value) => {
        // don't pass null (while editing date manually)
        if (date) {
            const value = date instanceof Date ? dateToApiDate(date) : '';
            onChange(value);
        }
        // set to empty string when clearing to trigger validation
        if (date === null && value === undefined) {
            onChange('');
        }
    }, [dateToApiDate, onChange]);
    return (_jsx(WithEndDecorator, { emptyEndDecorator: emptyEndDecorator, endDecorator: endDecorator, decoratorComponent: _jsx(DatePicker, { dataName: dataName ? dataName : '', ref: ref, onChange: handleChange, value: value === null ? null : apiDateToDate(value), inputFormat: dateFormat, ...otherProps }) }));
});
